export default __webpack_public_path__ + "static/media/linkedin.09217d55.svg";